import { PageBreadcrumb } from '@/components/ui/PageBreadcrumb'
import { SubscribeCta } from '@/components/website/SubscribeCta'
import { useWebsiteTestimonials } from '@/services/httpServices/queries/useWebsite'

/**
 * Public testimonials page. Cards are managed from the dashboard
 * (Website → Testimonials) and fetched from the API, falling back to the
 * bundled demo content when the API is unreachable.
 */
export function Testimonials() {
  const { testimonials } = useWebsiteTestimonials()

  return (
    <>
      <PageBreadcrumb title="Testimonials" />

      {/* testimonials section start */}
      <section className="testimonials-section-2 pt-100 md-pt-80 pb-100 md-pb-80">
        <div className="container">
          <div className="row">
            {testimonials.map((testimonial) => (
              <div className="col-xl-4 col-lg-6 col-md-6" key={testimonial.id}>
                {/* testimonials item start */}
                <div className="testimonials-item background-one">
                  <div className="testimonials-meta">
                    <div className="testimonials-rating">
                      {Array.from({ length: 5 }).map((_, index) => (
                        <i
                          key={index}
                          className={`fa-solid fa-star${index < testimonial.rating ? ' active' : ''}`}
                        ></i>
                      ))}
                    </div>
                    <div className="testimonials-quote">
                      <figure>
                        <img src="/assets/images/testimonials/quote.png" alt="quote" />
                      </figure>
                    </div>
                  </div>
                  <div className="testimonials-content">
                    {testimonial.title ? <h2>{testimonial.title}</h2> : null}
                    <p>{testimonial.quote}</p>
                  </div>
                  <div className="testimonials-author">
                    <div className="testimonials-author-image">
                      <figure>
                        {testimonial.image ? (
                          <img src={testimonial.image} alt={testimonial.name} />
                        ) : (
                          <i className="fa-solid fa-user"></i>
                        )}
                      </figure>
                    </div>
                    <div className="testimonials-author-content">
                      <h3>{testimonial.name}</h3>
                      <p>{testimonial.role}</p>
                    </div>
                  </div>
                </div>
                {/* testimonials item end */}
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* testimonials section end */}

      <SubscribeCta />
    </>
  )
}
